export default {
  authDrawerOpen: false,
  step: "",
  emailAvailable: true,
  userData: {},
  authToken: "",
  passwordResetToken: "",
  passwordResetEmail: "",
  emailConfirmed: false,
  emailConfirmError: false,
};



// WEBPACK FOOTER //
// ./src/reducers/initialState/authDrawer.js